import { useAuth } from '@shared/auth';
import { ConfirmationModal, Text, LogoutRoundedIcon } from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import MenuItem, { type MenuItemProps } from '../menu-item';

type LogoutMenuItemProps = Partial<MenuItemProps>;

function LogoutMenuItem(props: Readonly<LogoutMenuItemProps>) {
  const [isOpen, { open, close }] = useDisclosure(false);

  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    close();
  };

  return (
    <>
      <MenuItem {...props} label='ออกจากระบบ' icon={<LogoutRoundedIcon />} onClick={open} />
      <ConfirmationModal
        open={isOpen}
        title='ออกจากระบบ'
        content={<Text>คุณต้องการออกจากระบบใช่หรือไม่?</Text>}
        acceptText='ยืนยัน'
        discardText='ยกเลิก'
        onAccept={handleLogout}
        onDiscard={close}
      />
    </>
  );
}

export default LogoutMenuItem;
